import React, { useState, useEffect } from "react";
import { Mail, MapPin, Globe, Users } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800/50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 via-blue-500 to-yellow-500 rounded-2xl flex items-center justify-center shadow-xl">
                <span className="text-white font-black text-2xl">KM</span>
              </div>
              <div>
                <h3 className="text-white font-black text-2xl">
                  Kuba Meridian Group
                </h3>
                <p className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-emerald-400 to-blue-400 font-bold">
                  Building Africa's Future, Together
                </p>
              </div>
            </div>
            <p className="text-slate-300 leading-relaxed mb-8 max-w-md text-lg">
              A dynamic holding company uniting excellence, tradition, and
              innovation to transform industries across Africa and beyond.
            </p>
            <div className="text-slate-400">
              <p className="font-medium">
                © 2024 Kuba Meridian Group Holding (Pty) Ltd.
              </p>
              <p className="text-sm">All rights reserved.</p>
            </div>
          </div>

          {/* Subsidiaries */}
          <div>
            <h4 className="text-white font-bold mb-6 text-xl">
              Our Subsidiaries
            </h4>
            <ul className="space-y-3 text-slate-300">
              <li>
                <a
                  href="#"
                  className="hover:text-yellow-400 transition-colors text-lg"
                >
                  Malikia Consulting Engineers
                </a>
              </li>
              <li className="text-slate-500 italic">
                More subsidiaries coming soon...
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-6 text-xl">Contact</h4>
            <ul className="space-y-4 text-slate-300">
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                <span className="text-lg">info@kubameridian.com</span>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <span className="text-lg">Johannesburg, SA</span>
              </li>
              <li className="flex items-center space-x-3">
                <Globe className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <span className="text-lg">www.kubameridian.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="flex space-x-8 text-slate-400">
              {["Privacy Policy", "Terms of Service", "Cookie Policy"].map(
                (link, index) => (
                  <a
                    key={index}
                    href="#"
                    className="hover:text-yellow-400 transition-colors font-medium"
                  >
                    {link}
                  </a>
                )
              )}
            </div>

            <div className="flex items-center space-x-6">
              <span className="text-slate-400 font-medium">Follow us:</span>
              <div className="flex space-x-3">
                {[
                  {
                    icon: <Globe className="w-4 h-4" />,
                    hover: "hover:bg-yellow-500",
                  },
                  {
                    icon: <Users className="w-4 h-4" />,
                    hover: "hover:bg-emerald-500",
                  },
                  {
                    icon: <Mail className="w-4 h-4" />,
                    hover: "hover:bg-blue-500",
                  },
                ].map((social, index) => (
                  <a
                    key={index}
                    href="#"
                    className={`w-10 h-10 bg-slate-800 ${social.hover} rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-lg`}
                  >
                    <span className="text-slate-400 hover:text-white transition-colors">
                      {social.icon}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
